/* eslint-disable no-restricted-imports */
import { Box, TextField } from '@material-ui/core';

import { CustomerCard, CustomerSearchAsync } from 'components/Contigo';
import PropTypes from 'prop-types';

export default function CustomerSelectionStep({
  orderNumber,
  onOrderNumberChange,
  selectedCustomer,
  onCustomerChange,
}) {
  return (
    <Box>
      <Box mb={3}>
        <TextField
          fullWidth
          label='Número do Pedido (opcional)'
          variant='outlined'
          placeholder='Ex: CTG-2025-001 ou deixe em branco para gerar automaticamente'
          value={orderNumber}
          onChange={(e) => onOrderNumberChange(e.target.value)}
          helperText='Se não preencher, será gerado automaticamente'
        />
      </Box>

      <Box mb={3}>
        <CustomerSearchAsync
          value={selectedCustomer}
          onChange={onCustomerChange}
          label='Buscar Cliente'
          placeholder='Digite o nome ou CNPJ do cliente...'
        />
      </Box>

      {selectedCustomer && <CustomerCard customer={selectedCustomer} />}
    </Box>
  );
}

CustomerSelectionStep.propTypes = {
  orderNumber: PropTypes.string,
  onOrderNumberChange: PropTypes.func.isRequired,
  selectedCustomer: PropTypes.object,
  onCustomerChange: PropTypes.func.isRequired,
};
